import React from 'react';
import { Alert, Label, Form, FormGroup, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import Loader from '../../../components/Common/Loader';
import RoundedButton from '../../../components/Buttons/RoundedButton/RoundedButton';

// actions
import { loginUser } from '../../../store/actions';

import '../Forms.scss';

const LoginForm = (props) => {

	function handleOnSubmit(event) {
		event.preventDefault();
		let values = {
			email: event.target.email.value, 
			password: event.target.password.value
		};
		props.loginUser(values, props.history);
	}

	return (
		<div className="p-2">
			{props.loading ? (
				<Loader />
			) : <>
			{props.error ? (
				<Alert color="danger">{props.error}</Alert>
			) : null}
			<Form className="form-horizontal" onSubmit={handleOnSubmit}>
				<FormGroup className="auth-form-group-custom mb-4">
					{/* <i className="ri-user-2-line auti-custom-input-icon"></i> */}
					<Label className="d-block text-center" htmlFor="email">
						Mail
					</Label>
					<Input
						name="email"
						type="text"
						className="form-control"
						style={{ padding: '1.5em 1.5em' }}
						id="email"
						placeholder="mariorossi@hitreview.it"
					/>
				</FormGroup>

				<FormGroup className="auth-form-group-custom mb-4">
					{/* <i className="ri-lock-2-line auti-custom-input-icon"></i> */}
					<Label className="d-block text-center" htmlFor="userpassword">
						Password
					</Label>
					<Input
						name="password"
						type="password"
						className="form-control"
						id="userpassword"
						style={{ padding: '1.5em 1.5em' }}
						placeholder="••••••••••••••••"
					/>
				</FormGroup>

				<div className="mt-4 mb-5 text-center">
					<RoundedButton color="primary" className="w-50" type="submit">
						ACCEDI
					</RoundedButton>
				</div>

				<p className="mt-4 text-center">
					Hai dimenticato la password?
					<br />
					<Link to="/forgot-password" className="d-inline">
						{/* <i className="mdi mdi-lock mr-1"></i> */}
						Richiedi il ripristino
					</Link>
				</p>

				<p className="mt-4 text-center">
					Non hai un account?{' '}
					<Link to="/register" className="d-inline">
						{/* <i className="mdi mdi-lock mr-1"></i> */}
						Registrati
					</Link>
				</p>
			</Form>
			</>}
		</div>
	);
};

const mapStatetoProps = (state) => {
	const { error, loading, user } = state.Auth;
	return { error, loading, user };
};

export default withRouter(connect(mapStatetoProps, { loginUser })(LoginForm));
